module.exports = __webpack_public_path__ + "img/image12.d09f91a3.png";